/** Поля для v1 формулы заполненности профиля (admin CRM). */
export type ProfileCompletenessInput = {
  firstName: string | null;
  photoUrl: string | null;
  headline: string | null;
  superpower: string | null;
  bioRole: string | null;
  roleTags: readonly string[];
  skillTags: readonly string[];
  industryTags: readonly string[];
  requestTags: readonly string[];
  socionicsType: string | null;
  spokenLanguages: readonly string[];
};

const WEIGHTS = {
  firstName: 10,
  photoUrl: 15,
  headline: 10,
  superpower: 10,
  bioRole: 10,
  anyRoleTag: 10,
  anySkillTag: 10,
  anyIndustryTag: 5,
  anyRequestTag: 5,
  socionicsType: 15,
  anyLanguage: 10,
} as const;

const TOTAL_WEIGHT = Object.values(WEIGHTS).reduce((sum, w) => sum + w, 0);

/**
 * Доля заполненных блоков визитки/анкеты (0–100); веса относительные, итог нормирован к 100. Веса v1 — см. wiki/gaps при смене продукта.
 */
export function computeProfileCompletenessPercent(input: ProfileCompletenessInput): number {
  let score = 0;
  if (input.firstName?.trim()) score += WEIGHTS.firstName;
  if (input.photoUrl?.trim()) score += WEIGHTS.photoUrl;
  if (input.headline?.trim()) score += WEIGHTS.headline;
  if (input.superpower?.trim()) score += WEIGHTS.superpower;
  if (input.bioRole?.trim()) score += WEIGHTS.bioRole;
  if (input.roleTags.length > 0) score += WEIGHTS.anyRoleTag;
  if (input.skillTags.length > 0) score += WEIGHTS.anySkillTag;
  if (input.industryTags.length > 0) score += WEIGHTS.anyIndustryTag;
  if (input.requestTags.length > 0) score += WEIGHTS.anyRequestTag;
  if (input.socionicsType?.trim()) score += WEIGHTS.socionicsType;
  if (input.spokenLanguages.length > 0) score += WEIGHTS.anyLanguage;
  // Нормируем на сумму весов: иначе 100% выходило и с незаполненными блоками.
  return Math.round((score * 100) / TOTAL_WEIGHT);
}
